

// function initProductCardSlideshows(root = document) {
//   root.querySelectorAll('product-card slideshow-component').forEach((card) => {

//     if (card.dataset.customInitialized === 'true') return;
//     card.dataset.customInitialized = 'true';


//     card.setAttribute('disabled', false);

//     card.addEventListener('touchend', function () {
//       setTimeout(() => {
//         const firstSlide = this.querySelector('slideshow-slides slideshow-slide:nth-child(1)');

//         if (firstSlide && firstSlide.getAttribute('aria-hidden') === 'false') {
//           this.closest('product-card').classList.remove('mobile-hover-active');
//         } else {
//           this.closest('product-card').classList.add('mobile-hover-active');
//         }
//       }, 300);
//     });

//   });
// }

// initProductCardSlideshows();

const productCardObserver = new MutationObserver(() => {
  initProductCardSlideshows();
});

productCardObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// document.querySelectorAll('product-card slideshow-component').forEach((card) => {console.log('A');
//   card.setAttribute('disabled', false);

//   card.addEventListener('touchend', function () {
//     setTimeout(() => {console.log('B');
//       const firstSlide = this.querySelector('slideshow-slides slideshow-slide:nth-child(1)');

//       if (firstSlide && firstSlide.getAttribute('aria-hidden') === 'false') {
//         this.closest('product-card').classList.remove('mobile-hover-active');
//       } else {
//         this.closest('product-card').classList.add('mobile-hover-active');
//       }
//     }, 300);
//   });
// });


// document.querySelectorAll('product-card .product-mobile-loop-carousel').forEach((card) => {console.log('A');
//   card.setAttribute('disabled', false);

//   card.addEventListener('touchend', function () {console.log('B');
//     setTimeout(() => {
//       const firstSlide = this.querySelector('product-mobile-loop-carousel__slide:first-child');

//       if (firstSlide && firstSlide.getAttribute('aria-hidden') === 'false') {
//         this.closest('product-card').classList.remove('mobile-hover-active');
//       } else {
//         this.closest('product-card').classList.add('mobile-hover-active');
//       }
//     }, 200);
//   });
// });




// Ensure the DOM is fully loaded before running initial checks
// document.addEventListener('DOMContentLoaded', () => {
    
//     const radios = document.querySelectorAll('.variant-picker__form input[type="radio"]');
//     radios.forEach(radio => {
//         radio.addEventListener('change', function(){
          
//           const shippingTexts = document.querySelectorAll('.custom-inventory .inventory-item');
//           shippingTexts.forEach(textDiv => {
//             textDiv.classList.remove('active');
//           });

//           const variantId = this.dataset.variantId;
//           document.querySelector('.custom-inventory .id'+variantId).classList.toggle('active');
//         });
//     });
// });


// Register a listener on the document or a specific product section
document.addEventListener('variant:update', function(event) {
  const variant = event.detail.resource;
  
  // if(event.detail.resource.available == true){
  //   document.querySelector('main[data-template="product"] add-to-cart-component .add-to-cart-button').style.display = 'block';
  // }

  if (variant) {
    const shippingTexts = document.querySelectorAll('.custom-inventory .inventory-item');
    shippingTexts.forEach(textDiv => {
      textDiv.classList.remove('active');
    });

    const variantId = variant.id;
    document.querySelector('.custom-inventory .id'+variantId).classList.toggle('active');
  }
});



// const variant_buttons = document.querySelectorAll('variant-picker label');
// variant_buttons.forEach(t => {
//   t.addEventListener('click', function(e){
//     document.querySelector('main[data-template="product"] add-to-cart-component .add-to-cart-button').style.display = 'none';
//   });
// });




// document.addEventListener('variant:selected', function(event) {
//   const ele = event.target.closest('.product-content-wrapper').querySelector('.product-form-buttons button.add-to-cart-button');
//   ele.setAttribute('disabled', true);
// });




/* To manage Active status on Custom Tab/Menu of pages at top */

function support_centre_url(){
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);
  const hcUrl = urlParams.get('hcUrl');
  
  if(currentUrl.includes('support-centre')){
    if(document.querySelector('.details-content[aria-label="support-center-link"] ul li.active')){
      document.querySelector('.details-content[aria-label="support-center-link"] ul li.active').classList.remove('active');
    }

    if (hcUrl) {
      if(hcUrl.includes('shipping-and-delivery')){
        document.querySelector('.details-content[aria-label="support-center-link"] ul li:nth-child(2)').classList.add('active');
      }
      else if(hcUrl.includes('returns-and-exchanges')){
        document.querySelector('.details-content[aria-label="support-center-link"] ul li:nth-child(3)').classList.add('active');
      }
      else{
        document.querySelector('.details-content[aria-label="support-center-link"] ul li:nth-child(1)').classList.add('active');
      }
    }
    else{
      document.querySelector('.details-content[aria-label="support-center-link"] ul li:nth-child(1)').classList.add('active');
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  support_centre_url();
});





/* PDP - Pill tabs */


const pills_popup = document.querySelector('.product_link_popups');

if(pills_popup){
  const pills_tabs_trigger = pills_popup.querySelectorAll('button[data-tab-index]');

  pills_tabs_trigger.forEach(t => {
    t.addEventListener('click', function(e){
      const indexId = t.dataset.tabIndex;
      console.log('indexId', indexId);
      
      if(t.closest('dialog-component').querySelector('.tab-btn.active'))
        t.closest('dialog-component').querySelector('.tab-btn.active').classList.remove('active');

      if(t.closest('dialog-component').querySelector('.tab-content.active'))
        t.closest('dialog-component').querySelector('.tab-content.active').classList.remove('active');

      t.classList.add('active');

      t.closest('dialog-component').querySelector('.tab-btn[data-tab-index="'+indexId+'"]').classList.add('active');
      t.closest('dialog-component').querySelector('.tab-content[data-tab-content="'+indexId+'"]').classList.add('active');
    })
  })
}




// Open Size chart model on fit shape text on top of Prodcut title

var fitShapeEle = document.querySelector('.product-details .details-header .group-block-content > rte-formatter p');

if(fitShapeEle){
  fitShapeEle.addEventListener('click', function(event){
    fitShapeEle.closest('.product-details').querySelector('.ks-chart-modal-link').click();
  });
}





// Limit mobile product card swipes to one image per gesture.
(() => {
  let swipe = null;
  let suppressClick = null;

  const mobile = window.matchMedia('(max-width: 749px)');

  document.addEventListener('touchstart', (event) => {
    if (!mobile.matches || event.touches.length !== 1) return;
    if (!(event.target instanceof Element)) return;

    const scroller = event.target.closest('.card-gallery slideshow-slides');
    const slideshow = scroller?.closest('slideshow-component');

    if (!slideshow || slideshow.disabled || slideshow.slides?.length < 2) return;

    const touch = event.touches[0];

    suppressClick = null;

    swipe = {
      id: touch.identifier,
      x: touch.clientX,
      y: touch.clientY,
      index: slideshow.current,
      slideshow,
      horizontal: false,
    };
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!swipe) return;

    const touch = [...event.touches].find(t => t.identifier === swipe.id);
    if (!touch) return;

    const dx = touch.clientX - swipe.x;
    const dy = touch.clientY - swipe.y;

    if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      swipe.horizontal = true;
    }

    // Block native horizontal scrolling, but allow vertical page scrolling.
    if (swipe.horizontal && event.cancelable) {
      event.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', (event) => {
    if (!swipe) return;

    const touch = [...event.changedTouches].find(t => t.identifier === swipe.id);
    if (!touch) return;

    const { x, y, index, slideshow, horizontal } = swipe;
    swipe = null;

    const dx = touch.clientX - x;
    const dy = touch.clientY - y;

    if (!horizontal || Math.abs(dx) < 25 || Math.abs(dx) <= Math.abs(dy)) return;


    // Add class on right swipe, remove it on left swipe.
    const productCard = slideshow.closest('product-card');
    productCard?.classList.toggle('mobile-hover-active', dx < 0);


    const nextIndex = Math.max(
      0,
      Math.min(slideshow.slides.length - 1, index + (dx < 0 ? 1 : -1))
    );

    // Prevent a swipe from opening the product page.
    suppressClick = {
      gallery: slideshow.closest('.card-gallery'),
      until: Date.now() + 500,
    };

    
    // Change exactly one image per swipe without scroll animation.
    slideshow.select(nextIndex, undefined, { animate: true });

  }, { passive: true });

  document.addEventListener('touchcancel', () => {
    swipe = null;
  }, { passive: true });

  document.addEventListener('click', (event) => {
    if (
      suppressClick &&
      Date.now() < suppressClick.until &&
      suppressClick.gallery?.contains(event.target)
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = null;
    }
  }, true);
})();